(function () {
  if (window.wlySliderReady) return;
  window.wlySliderReady = true;

  function findList(arrows) {
    var scope = arrows.closest('.shopify-section') || document;
    var lists = scope.querySelectorAll('[data-wly-slider]');
    var index = parseInt(arrows.getAttribute('data-wly-sa-index') || '1', 10) - 1;
    return lists[index] || null;
  }

  function stepSize(list) {
    var items = list.children;
    var gap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
    for (var i = 0; i < items.length; i++) {
      var width = items[i].getBoundingClientRect().width;
      if (width > 0) return width + gap;
    }
    return list.clientWidth;
  }

  function update(arrows, list) {
    var prev = arrows.querySelector('[data-wly-sa-prev]');
    var next = arrows.querySelector('[data-wly-sa-next]');
    if (!prev || !next) return;
    var max = list.scrollWidth - list.clientWidth - 2;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft >= max;
  }

  function init(arrows) {
    if (arrows.getAttribute('data-wly-sa-ready')) return;
    var list = findList(arrows);
    if (!list) return;
    arrows.setAttribute('data-wly-sa-ready', 'true');
    if (!list.id) list.id = 'wly-slider-' + Math.random().toString(36).slice(2, 9);
    var buttons = arrows.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-controls', list.id);
    list.addEventListener('scroll', function () { update(arrows, list); }, { passive: true });
    window.addEventListener('resize', function () { update(arrows, list); });
    update(arrows, list);
  }

  function boot(root) {
    var all = (root || document).querySelectorAll('[data-wly-slider-arrows]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var button = event.target.closest('[data-wly-sa-prev], [data-wly-sa-next]');
    if (!button) return;
    var arrows = button.closest('[data-wly-slider-arrows]');
    var list = arrows ? findList(arrows) : null;
    if (!list) return;
    var direction = button.hasAttribute('data-wly-sa-prev') ? -1 : 1;
    list.scrollBy({ left: stepSize(list) * direction, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
